const TagCategory = Object.freeze({
  CUSTOM: 'custom',
  NOT_TAGGED: 'not_tagged',
  PRIMARY: 'primary',
  SYSTEM: 'system',
});

export default TagCategory;
